module.exports = __webpack_public_path__ + "img/bg-map-image.webp";